// i18n types
export var LANGUAGES;
(function (LANGUAGES) {
    LANGUAGES["ES"] = "es";
    LANGUAGES["PT"] = "pt";
    LANGUAGES["EN"] = "en";
})(LANGUAGES || (LANGUAGES = {}));
export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["FACEBOOK"] = "facebook";
    AuthProvider["GOOGLE"] = "google-oauth2";
    AuthProvider["LINKEDIn"] = "linkedin";
    AuthProvider["TWITTER"] = "twitter";
})(AuthProvider || (AuthProvider = {}));
//# sourceMappingURL=types.js.map